import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const About = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <Box textAlign="center">
        <Typography variant="h1" component="h1" gutterBottom>
          Über NoBNoHungry
        </Typography>
        <Typography color="text.secondary">
          Transparenz ist uns wichtig. Hier findest du alle rechtlichen Informationen zu dieser Anwendung.
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ p: { xs: 3, md: 4 } }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Impressum
        </Typography>
        <Typography gutterBottom>Angaben gemäß § 5 TMG</Typography>
        <Typography>Daniel Hörenkamp</Typography>
        <Typography>Kreuzstraße 69</Typography>
        <Typography>44575 Castrop-Rauxel</Typography>

        <Box mt={3}>
          <Typography variant="h6" component="h3" gutterBottom>
            Kontakt
          </Typography>
          <Typography>
            E-Mail:{' '}
            <Link href="mailto:d.hoerenkamp@gmail.com" underline="hover">
              d.hoerenkamp@gmail.com
            </Link>
          </Typography>
        </Box>

        <Box mt={3}>
          <Typography variant="h6" component="h3" gutterBottom>
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </Typography>
          <Typography>Daniel Hörenkamp</Typography>
          <Typography>Kreuzstraße 69</Typography>
          <Typography>44575 Castrop-Rauxel</Typography>
        </Box>
      </Paper>

      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, md: 4 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h5" component="h2">
          Datenschutzerklärung
        </Typography>
        <Divider />
        <Typography>
          Wir nehmen den Schutz deiner persönlichen Daten sehr ernst. Nachfolgend informieren wir dich darüber,
          welche Daten wir erheben und wie wir sie verarbeiten.
        </Typography>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            1. Verantwortlicher
          </Typography>
          <Typography>Daniel Hörenkamp</Typography>
          <Typography>Kreuzstraße 69</Typography>
          <Typography>44575 Castrop-Rauxel</Typography>
          <Typography>
            E-Mail:{' '}
            <Link href="mailto:d.hoerenkamp@gmail.com" underline="hover">
              d.hoerenkamp@gmail.com
            </Link>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            2. Welche Daten werden gespeichert?
          </Typography>
          <List dense disablePadding>
            <ListItem disableGutters>
              <ListItemText primary="Registrierungsdaten (E-Mail-Adresse, verschlüsseltes Passwort)" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Ernährungsdaten wie Lebensmittel, Menge, Kalorien und Mahlzeit" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Optionale Profildaten (Alter, Größe, Gewicht, Aktivitätslevel, Ziele)" />
            </ListItem>
          </List>
        </Box>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            3. Wofür nutzen wir deine Daten?
          </Typography>
          <List dense disablePadding>
            <ListItem disableGutters>
              <ListItemText primary="Zur Bereitstellung und Verbesserung unserer Tracking-Funktionen" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Zur personalisierten Darstellung deiner Tages- und Wochenübersichten" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Zur Analyse deines Fortschritts und zur Unterstützung deiner Ziele" />
            </ListItem>
          </List>
        </Box>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            4. Weitergabe von Daten
          </Typography>
          <Typography>
            Eine Weitergabe deiner personenbezogenen Daten an Dritte findet nicht statt. Alle Daten werden ausschließlich
            zur Nutzung innerhalb von NoBNoHungry verarbeitet.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            5. Speicherdauer
          </Typography>
          <Typography>
            Deine Daten werden so lange gespeichert, wie du ein aktives Nutzerkonto hast. Du kannst jederzeit die Löschung
            deiner Daten beantragen.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            6. Deine Rechte
          </Typography>
          <List dense disablePadding>
            <ListItem disableGutters>
              <ListItemText primary="Auskunft über die gespeicherten Daten" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Berichtigung fehlerhafter Daten" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Löschung deiner Daten oder Einschränkung der Verarbeitung" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Widerspruch gegen die Verarbeitung" />
            </ListItem>
          </List>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Wenn du Fragen zur Datennutzung hast oder deine Rechte ausüben möchtest, schreibe uns gerne an{' '}
          <Link href="mailto:d.hoerenkamp@gmail.com" underline="hover">
            d.hoerenkamp@gmail.com
          </Link>
          .
        </Typography>
      </Paper>
    </Container>
  );
};

export default About;
